import React from "react";
import styled, { withTheme } from "styled-components/macro";
import { Card as MuiCard, CardContent, CardHeader } from "@material-ui/core";

import { spacing } from "@material-ui/system";

import { fade } from "@material-ui/core/styles/colorManipulator";

import { Line } from "react-chartjs-2";
import { fontSizes } from "../../../../constants/designSystem";

const Card = styled(MuiCard)(spacing);

const ChartWrapper = styled.div`
  height: 378px;
`;

const MONTHS = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
];

const currency = Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

function LineChart({ theme, salesInvestmentData }) {
  const titles = ["Vendas aprovadas", "Investimento"];

  const data = (canvas) => {
    const firstDatasetColor = theme.palette.secondary.main;
    const secondDatasetColor =
      theme.palette.type === "dark"
        ? "rgba(255, 255, 255, 0.5)"
        : "rgba(0, 0, 0, 0.15)";

    const ctx = canvas.getContext("2d");

    const gradient = ctx.createLinearGradient(0, 0, 0, 300);
    gradient.addColorStop(0, fade(theme.palette.secondary.main, 0.0875));
    gradient.addColorStop(1, "rgba(0, 0, 0, 0)");

    const { labels, investments, approvedSales } = salesInvestmentData
      .sort((a, b) =>
        a._id.year !== b._id.year
          ? a._id.year - b._id.year
          : a._id.month - b._id.month
      )
      .reduce(
        (acc, month) => {
          acc.labels.push(MONTHS[month._id.month - 1]);
          acc.investments.push(month.mediaInvestment);
          acc.approvedSales.push(month.approvedSales);

          return acc;
        },
        { labels: [], investments: [], approvedSales: [] }
      );

    return {
      labels,
      datasets: [
        {
          label: titles[0],
          fill: false,
          backgroundColor: firstDatasetColor,
          borderColor: theme.palette.secondary.main,
          hoverBackgroundColor: firstDatasetColor,
          hoverBorderColor: firstDatasetColor,
          data: approvedSales,
        },
        {
          label: titles[1],
          fill: false,
          backgroundColor: "transparent",
          borderColor: theme.palette.grey[500],
          hoverBackgroundColor: secondDatasetColor,
          hoverBorderColor: secondDatasetColor,
          borderDash: [4, 4],
          data: investments,
        },
      ],
    };
  };

  const label = (tooltip) => {
    return (
      titles[tooltip.datasetIndex] + ": " + currency.format(tooltip.yLabel)
    );
  };

  const options = {
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    tooltips: {
      intersect: false,
      mode: "index",
      callbacks: {
        label,
      },
      titleFontSize: fontSizes.normal,
      bodyFontSize: fontSizes.medium,
      footerFontSize: fontSizes.medium,
    },
    hover: {
      intersect: true,
    },
    plugins: {
      filler: {
        propagate: false,
      },
    },
    scales: {
      xAxes: [
        {
          reverse: true,
          gridLines: {
            color: "rgba(0,0,0,0.0)",
          },
          ticks: {
            fontColor: theme.palette.text.secondary,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: theme.palette.text.secondary,
            callback: (value) => currency.format(value),
          },
          display: true,
          borderDash: [5, 5],
          gridLines: {
            color: "rgba(0,0,0,0.0375)",
            fontColor: "#fff",
          },
        },
      ],
    },
  };

  return (
    <Card mb={3}>
      <CardHeader title="Vendas aprovadas vs Investimento" />
      <CardContent>
        <ChartWrapper>
          <Line data={data} options={options} />
        </ChartWrapper>
      </CardContent>
    </Card>
  );
}
export default withTheme(LineChart);
